import RolesType from '@portal/enum/rolesType';
import { Route } from '@portal/models/module';

export const tabRolesFilter = (route: Route, roles: string[]) => {
  if (roles.some((role) => role === RolesType.MY_ACCOUNT)) {
    return true;
  }

  return route.roles?.some((routeRole) => roles.includes(routeRole));
};
